import { render, staticRenderFns } from "./RelocateGoodsPopup.vue?vue&type=template&id=573ee8cc&scoped=true"
import script from "./RelocateGoodsPopup.vue?vue&type=script&lang=js"
export * from "./RelocateGoodsPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573ee8cc",
  null
  
)

export default component.exports